import { render, staticRenderFns } from "./SvgPrepareScreen.vue?vue&type=template&id=4022aee6&scoped=true&"
import script from "./SvgPrepareScreen.vue?vue&type=script&lang=js&"
export * from "./SvgPrepareScreen.vue?vue&type=script&lang=js&"
import style0 from "./SvgPrepareScreen.vue?vue&type=style&index=0&id=4022aee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4022aee6",
  null
  
)

export default component.exports